import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import PageHeader from '../../components/PageHeader';
import PinCodeInput from '../../components/PinCodeInput/PinCodeInput';
import AppConfig from '../../config';
import { t } from '../../lang';
import HelperService from '../../services/HelperService';
import RequestService from '../../services/RequestService';
import { appSlice, authSlice } from '../../store/slices';

import { getDeviceInfo } from '../../hooks/useDeviceInfo';
import './CreatePin.scss';

const { routes } = AppConfig;

const CreatePin = () => {
	const pin = useSelector(state => state.auth.pin);
	const initDataTG = useSelector(state => state.app.initDataTG);
	const username = useSelector(state => state.auth.username);
	const password = useSelector(state => state.auth.password);
	const location = useLocation();

	const dispatch = useDispatch();
	const navigate = useNavigate();

	useEffect(() => {
		dispatch(authSlice.actions.setPin());
	}, []);

	const updatePin = pin => {
		dispatch(authSlice.actions.setPin(pin));
	};

	const goToConfirm = pin => {
		dispatch(
			appSlice.actions.setPinConfirm({
				header: 'Confirm PIN-code',
				subheader: 'Create a PIN code that will be used to log in and confirm transactions.',
				confirmHandler: async confirmPin => {
					dispatch(appSlice.actions.setPinConfirmProps({ status: confirmPin === pin ? 'success' : 'error' }));

					if (confirmPin === pin) {
						if (location.state?.flow === 'recoverPin') {
							try {
								const deviceInfo = await getDeviceInfo();
								const { fingerprintId } = deviceInfo;
								const response = await RequestService.SetNewPinCode(username, password, pin, fingerprintId, initDataTG);

								if (response.Status === 'Success') {
									HelperService.showNotification({
										type: 'success',
										title: t('Successful'),
										description: t('PIN-code has been restored'),
									});

									dispatch(appSlice.actions.setToken(response.Token));
									navigate(routes.mainPage);
								}
							} catch (error) {
								console.log('error', error);
							}
						}

						if (location.state?.flow === 'signUp') {
							navigate(routes.createPassword);
						}
					}
				},
			})
		);

		navigate(routes.enterPin);
	};

	return (
		<div className='CreatePin'>
			<PageHeader
				header={'Create PIN-code'}
				subheader={'Create a PIN code that will be used to log in and confirm transactions.'}
			/>
			<div className='CreatePin__body'>
				<PinCodeInput value={pin} onChange={updatePin} onFill={goToConfirm} />
			</div>
		</div>
	);
};

export default CreatePin;
